


















import {Component, Prop, Vue} from "vue-property-decorator";

@Component
export default class PlanModal extends Vue {
    @Prop({required: true}) title!: string;
}
